import { Card, Image } from "antd";
import React from "react";
import StarRatings from "react-star-ratings";

const { Meta } = Card;

function ProductCard({ product }) {
  return (
    <Card
      hoverable
      style={{ height: "100%" }}
      cover={
        <div
          style={{
            height: "200px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            alt={product.name}
            src={`${product.images}?v=${product.imageVersion}`}
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      }
    >
      <Meta
        title={product.name}
        description={`$${Number(product.price).toFixed(2)}`}
      />

      <div style={{ marginTop: "10px", textAlign: "center" }}>
        {product.averageRating > 0 ? (
          <>
            <StarRatings
              rating={product.averageRating}
              starRatedColor="gold"
              numberOfStars={5}
              starDimension="20px"
              starSpacing="2px"
            />
            <div>
              {product.averageRating.toFixed(1)} ⭐ ({product.ratingCount}{" "}
              reviews)
            </div>
            <div></div>
          </>
        ) : (
          <div>No reviews</div>
        )}
      </div>
    </Card>
  );
}

export default ProductCard;
